import AddTaskIcon from "@mui/icons-material/AddTask";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaveIcon from "@mui/icons-material/Save";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import * as React from "react";
import { useCallback, useEffect, useMemo } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import {
  CATEGORY_TICKET_COUNT,
  STATUS_TICKET_COUNT,
  TICKETS_LAST30DAYS_TREDND,
  TICKETS_CLOSED_TREDND,
  TICKETS_UNASSIGNED_TREDND,
  TICKETS_AGING_TREDND,
  TICKETS_STATUS_TREDND,
  TICKETS_CUSTOMER_SURVEY,
  TICKETS_SLA_STATUS,
  TICKETS_ESCALATED_STATS,
  TICKETS_SLA_COMPLIANCE
} from "../../../../Constants/Constants";
import {
  ROLE_BASED_DASHBOARD_SECTIONS,
  WIDGET_DEFINITIONS,
  WIDGET_COMPONENTS
} from "../../../../Constants/DashboardConstants";
import AxiosInstance from "../../../../services/AxiosInstance";
import {
  clearDashboardLayout,
  loadDashboardLayout,
  saveDashboardLayout,
} from "../../../../services/layoutStorageService";
import Copyright from "../internals/components/Copyright";

const ResponsiveGridLayout = WidthProvider(Responsive);

export default function MainGrid({ userRole }) {
  const [isEditMode, setIsEditMode] = React.useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [savedWidgets, setSavedWidgets] = React.useState(null);
  const [savedLayouts, setSavedLayouts] = React.useState(null);
  const [selectedSectionIndex, setSelectedSectionIndex] = React.useState(0);
  const editModeToggleRef = React.useRef({});

  const handleModeToggle = () => {
    editModeToggleRef.current = {};
    ROLE_BASED_DASHBOARD_SECTIONS[userRole].forEach((section) => {
      editModeToggleRef.current[section.id] = true;
    });
    setIsEditMode((prevMode) => !prevMode);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedSectionIndex(newValue);
  };
  const [categoryData, setCategoryData] = React.useState([]);
  const [statusData, setStatusData] = React.useState([]);
  const [last30DaysData, setLast30DaysData] = React.useState([]);
  const [closedTicketsData, setClosedTicketsData] = React.useState();
  const [unAssignedTicketsData, setUnAssignedTicketsData] = React.useState({});
  const [agingTicketsData, setAgingTicketsData] = React.useState({groups:[], seriesLabels:[]});  
  const [ticketsStatusData, setTicketsStatusData] = React.useState({});
  const [customerSurveyData, setCustomerSurveyData] = React.useState({});
  const [ticketSLAStatus, setTicketSLAStatus] = React.useState([]);
  const [ticketEscalationStats, setTicketEscalationStats] = React.useState({});
  const [slaCompliance, setSlaCompliance] = React.useState({});

  useEffect(() => {
    getTicketsCountByCategory();
    getTicketsCountByStatus();
    getLast30DaysTicketsTrend();
    getClosedTicketsByMonth();
    getUnAssignedTickets();
    getAgingTickets();
    getTicketsStatus();
    getTicketsCustomerSurvey();
    getTicketsSLAStatus();
    getTicketEscalationStats();
    getTicketSLACompliance();
  }, []);

  const getTicketsCountByCategory = async () => {
    await AxiosInstance.get(CATEGORY_TICKET_COUNT).then((response) =>
      setCategoryData(response.data)
    );
  };

  const getTicketsCountByStatus = async () => {
    await AxiosInstance.get(STATUS_TICKET_COUNT).then((response) =>
      setStatusData(response.data)
    );
  };

  const getLast30DaysTicketsTrend = async () => {
    await AxiosInstance.get(TICKETS_LAST30DAYS_TREDND).then((response) =>
      setLast30DaysData(response.data)
    );
  };

  const getClosedTicketsByMonth = async () => {
    await AxiosInstance.get(TICKETS_CLOSED_TREDND).then((response) =>
      setClosedTicketsData(response.data)
    );
  };

  const getUnAssignedTickets = async () => {
    await AxiosInstance.get(TICKETS_UNASSIGNED_TREDND).then((response) =>
      setUnAssignedTicketsData(response.data)
    );
  };

  const getAgingTickets = async () => {
    await AxiosInstance.get(TICKETS_AGING_TREDND).then((response) =>
      setAgingTicketsData(response.data)
    );
  };

  const getTicketsStatus = async () => {
    await AxiosInstance.get(TICKETS_STATUS_TREDND).then((response) =>
      setTicketsStatusData(response.data)
    );
  };

  const getTicketsCustomerSurvey = async () => {
    await AxiosInstance.get(TICKETS_CUSTOMER_SURVEY).then((response) =>
      setCustomerSurveyData(response.data)
    );
  }; 

  const getTicketsSLAStatus = async () => {
    await AxiosInstance.get(TICKETS_SLA_STATUS).then((response) =>
      setTicketSLAStatus(response.data)
    );
  }; 

  const getTicketEscalationStats = async () => {
    await AxiosInstance.get(TICKETS_ESCALATED_STATS).then((response) =>
      setTicketEscalationStats(response.data)
    );
  };
  
  const getTicketSLACompliance = async () => {
    await AxiosInstance.get(TICKETS_SLA_COMPLIANCE).then((response) =>
      setSlaCompliance(response.data)
    );
  };
  
  
  const initialWidgets = useMemo(
    () =>
      ROLE_BASED_DASHBOARD_SECTIONS[userRole].flatMap((section) =>
        section.widgets.map((widgetType) => ({
          i: widgetType,
          type: widgetType,
          sectionId: section.id,
          ...WIDGET_DEFINITIONS[widgetType].defaultLayout,
        }))
      ),
    [userRole]
  );

  const [widgets, setWidgets] = React.useState(initialWidgets);
  const initialLayouts = useMemo(() => {
    const layouts = {};
    ROLE_BASED_DASHBOARD_SECTIONS[userRole].forEach((section) => {
      layouts[section.id] = {
        lg: section.widgets.map((widgetType) => ({
          i: widgetType,
          type: widgetType,
          sectionId: section.id,
          ...WIDGET_DEFINITIONS[widgetType].defaultLayout,
        })),
      };
    });
    return layouts;
  }, [userRole]);
  const [layouts, setLayouts] = React.useState(initialLayouts);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openAddWidgetMenu = Boolean(anchorEl);

  const handleAddWidgetClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAddWidgetClose = () => {
    setAnchorEl(null);
  };

  const onRemoveItem = (itemId) => {
    setWidgets((prevWidgets) => prevWidgets.filter((w) => w.i !== itemId));
    setHasUnsavedChanges(true);
  };

  const handleToggleWidget = (widgetTypeKey, isChecked, sectionId) => {
    if (isChecked) {
      const isWidgetTypePresent = widgets.some((w) => w.type === widgetTypeKey);
      if (!isWidgetTypePresent) {
        const widgetDefinition = WIDGET_DEFINITIONS[widgetTypeKey];

        const sectionWidgets = widgets.filter((w) => w.sectionId === sectionId);

        const sectionLayouts = layouts[sectionId];
        const x =
          (sectionWidgets.length * widgetDefinition.defaultLayout.w) %
          (sectionLayouts?.lg?.length || 12);
        setWidgets((prevWidgets) => {
          return [
            ...prevWidgets,
            {
              i: widgetTypeKey,
              type: widgetTypeKey,
              sectionId,
              x,
              y: Infinity,
              ...widgetDefinition.defaultLayout,
            },
          ];
        });
        setHasUnsavedChanges(true);
      }
    } else {
      setWidgets((prevWidgets) =>
        prevWidgets.filter((w) => w.type !== widgetTypeKey)
      );
      setHasUnsavedChanges(true);
    }
  };

  const handleSaveLayout = () => {
    saveDashboardLayout(userRole, { widgets, layouts });
    setSavedWidgets([...widgets]);
    setSavedLayouts({ ...layouts });
    setHasUnsavedChanges(false);
  };

  const handleCancelChanges = () => {
    if (
      window.confirm(
        "Are you sure you want to cancel your changes? All unsaved modifications will be lost."
      )
    ) {
      if (savedWidgets) {
        setWidgets([...savedWidgets]);
      }
      if (savedLayouts) {
        setLayouts({ ...savedLayouts });
      }
      setHasUnsavedChanges(false);
    }
  };

  const handleResetLayout = () => {
    if (
      window.confirm(
        "Are you sure you want to reset the dashboard to default layout? This will remove all your customizations."
      )
    ) {
      setHasUnsavedChanges(true);
      clearDashboardLayout(userRole);
      setWidgets(initialWidgets);

      const initialSectionLayouts = {};
      ROLE_BASED_DASHBOARD_SECTIONS[userRole].forEach((section) => {
        initialSectionLayouts[section.id] = {};
      });

      setLayouts(initialSectionLayouts);
      setSavedWidgets([...initialWidgets]);
      setSavedLayouts(initialSectionLayouts);
      setHasUnsavedChanges(false);
    }
  };

  useEffect(() => {
    const loadSavedLayout = async () => {
      setIsLoading(true);
      try {
        const savedLayout = loadDashboardLayout(userRole);
        if (savedLayout) {
          console.log("Loading saved layout for role:", userRole);
          if (savedLayout.widgets) {
            setWidgets(savedLayout.widgets);
            setSavedWidgets(savedLayout.widgets);
          }
          if (savedLayout.layouts) {
            setLayouts(savedLayout.layouts);
            setSavedLayouts(savedLayout.layouts);
          }
        } else {
          setSavedWidgets(initialWidgets);

          const initialSectionLayouts = {};
          ROLE_BASED_DASHBOARD_SECTIONS[userRole].forEach((section) => {
            initialSectionLayouts[section.id] = {};
          });

          setLayouts(initialLayouts);
          setSavedLayouts(initialLayouts);
        }
      } catch (error) {
        console.error("Error loading saved layout:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadSavedLayout();
  }, [userRole, initialWidgets, initialLayouts]);

  const onLayoutChange = useCallback(
    (currentBreakpointLayout, allBreakpointLayouts, sectionId) => {
      if (!isEditMode) {
        return;
      }

      setLayouts((prevLayouts) => ({
        ...prevLayouts,
        [sectionId]: allBreakpointLayouts,
      }));

      if (!editModeToggleRef.current[sectionId]) {
        setHasUnsavedChanges(true);
      }
      editModeToggleRef.current[sectionId] = false;

      setWidgets((prevWidgets) => {
        const newWidgets = prevWidgets.map((widget) => {
          if (widget.sectionId !== sectionId) {
            return widget;
          }

          const layoutItem = currentBreakpointLayout.find(
            (l) => l.i === widget.i
          );
          if (layoutItem) {
            if (
              widget.x !== layoutItem.x ||
              widget.y !== layoutItem.y ||
              widget.w !== layoutItem.w ||
              widget.h !== layoutItem.h
            ) {
              return {
                ...widget,
                x: layoutItem.x,
                y: layoutItem.y,
                w: layoutItem.w,
                h: layoutItem.h,
                sectionId: widget.sectionId,
                type: widget.type,
              };
            }
          }
          return widget;
        });

        return newWidgets;
      });
    },
    [isEditMode]
  );

  const getDynamicPropsForType = (type) => {
    switch (type) {
      // case WIDGET_COMPONENTS.OPEN_TICKETS:
      //   return {
      //     data: last30DaysData,
      //   };
      // case WIDGET_COMPONENTS.TICKETS_BY_CATEGORY:
      //   return {
      //     data: categoryData,
      //   };
      // case WIDGET_COMPONENTS.TICKET_STATUS:
      //   return {
      //     data: statusData,
      //   };
      default:
        return {};
    }
  };

const [widgetDefs, setWidgetDefs] = React.useState(WIDGET_DEFINITIONS);

useEffect(() => {
    setWidgetDefs((prev) => ({
      ...prev,
      [WIDGET_COMPONENTS.OPEN_TICKETS]: {
        ...prev[WIDGET_COMPONENTS.OPEN_TICKETS],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.OPEN_TICKETS].defaultProps,
          data: last30DaysData,
        },
      },
      [WIDGET_COMPONENTS.CLOSED_TICKETS]: {
        ...prev[WIDGET_COMPONENTS.CLOSED_TICKETS],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.CLOSED_TICKETS].defaultProps,
          data: closedTicketsData,
        },
      },
      [WIDGET_COMPONENTS.UNASSIGNED_TICKETS]: {
        ...prev[WIDGET_COMPONENTS.UNASSIGNED_TICKETS],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.UNASSIGNED_TICKETS].defaultProps,
          value: unAssignedTicketsData.value,
          deltaPercent: unAssignedTicketsData.deltaPercent,
        },
      },
       [WIDGET_COMPONENTS.TICKET_AGING_REPORT]: {
        ...prev[WIDGET_COMPONENTS.TICKET_AGING_REPORT],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.TICKET_AGING_REPORT].defaultProps,
          groups: agingTicketsData?.groups,
          seriesLabels: agingTicketsData?.seriesLabels,
        },
      },
      [WIDGET_COMPONENTS.TICKET_STATUS]: {
        ...prev[WIDGET_COMPONENTS.TICKET_STATUS],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.TICKET_STATUS].defaultProps,
          data: ticketsStatusData,          
        },
      },
      [WIDGET_COMPONENTS.CUSTOMER_SATISFACTION_SCORE]: {
        ...prev[WIDGET_COMPONENTS.CUSTOMER_SATISFACTION_SCORE],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.CUSTOMER_SATISFACTION_SCORE].defaultProps,
          data: customerSurveyData,          
        },
      },
      [WIDGET_COMPONENTS.SLA_STATUS]: {
        ...prev[WIDGET_COMPONENTS.SLA_STATUS],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.SLA_STATUS].defaultProps,
          data: ticketSLAStatus,          
        },
      },
      
      [WIDGET_COMPONENTS.ESCALATED_TICKETS]: {
        ...prev[WIDGET_COMPONENTS.ESCALATED_TICKETS],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.ESCALATED_TICKETS].defaultProps,
          title: ticketEscalationStats.title,
          value: ticketEscalationStats.value,          
          deltaPercent: ticketEscalationStats.deltaPercent,          
        },
      },

      [WIDGET_COMPONENTS.SLA_COMPLIANCE]: {
        ...prev[WIDGET_COMPONENTS.SLA_COMPLIANCE],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.SLA_COMPLIANCE].defaultProps,
          data: slaCompliance
        },
      },
      
       [WIDGET_COMPONENTS.TICKETS_BY_CATEGORY]: {
        ...prev[WIDGET_COMPONENTS.TICKETS_BY_CATEGORY],
        defaultProps: {
          ...prev[WIDGET_COMPONENTS.TICKETS_BY_CATEGORY].defaultProps,
          data: categoryData
        },
      },
      
    }));
  }, [last30DaysData, closedTicketsData]);


  const renderWidget = (widgetDefinition, widgetType) => {
    if (!widgetDefinition) return null;

    const Component = widgetDefinition.component;
    return (
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.12)}`,
          borderRadius: "8px",
          overflow: "hidden",
          position: "relative",
          transition: "all 0.2s ease-in-out",
          ...(isEditMode && {
            "&:hover": {
              boxShadow: (theme) =>
                theme.palette.mode === "dark"
                  ? "0 2px 8px rgba(0, 0, 0, 0.4)"
                  : "0 2px 8px rgba(0, 0, 0, 0.5)",
              transform: "translateY(-2px)",
            },
          }),
        }}
      >
        <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              px: 2,
              py: 1.5,
              backgroundColor: (theme) =>
                alpha(theme.palette.primary.main, 0.04),
              borderBottom: (theme) =>
                `1px solid ${alpha(theme.palette.divider, 0.08)}`,
              position: "relative",
            }}
          >
            {isEditMode && (
              <DragIndicatorIcon
                className="drag-handle"
                sx={{
                  cursor: "grab",
                  color: "primary.main",
                  position: "absolute",
                  left: 8,
                  top: "50%",
                  transform: "translateY(-50%)",
                  opacity: 0.7,
                  "&:hover": { opacity: 1 },
                }}
              />
            )}
            <Typography
              component="h2"
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: "text.primary",
                ml: isEditMode ? 3 : 0,
                fontSize: "0.95rem",
              }}
            >
              {widgetDefinition.name}
            </Typography>
            {isEditMode && (
              <Tooltip title={`Remove ${widgetDefinition.name}`}>
                <IconButton
                  size="small"
                  onClick={() => onRemoveItem(widgetType)}
                  onMouseDown={(e) => e.stopPropagation()}
                  aria-label={`remove ${widgetDefinition.name}`}
                  sx={{
                    color: "error.main",
                    "&:hover": {
                      backgroundColor: (theme) =>
                        alpha(theme.palette.error.main, 0.1),
                    },
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
          <Box sx={{ flexGrow: 1, p: 2 }}>
            <Component
              {...widgetDefinition.defaultProps}
              {...getDynamicPropsForType(widgetType)}
            />
          </Box>
        </CardContent>
      </Card>
    );
  };

  const renderSection = (section) => {
    const sectionWidgets = widgets.filter(
      (widget) => widget.sectionId === section.id
    );

    return (
      <Box key={section.id} sx={{ mb: 4 }}>
        <ResponsiveGridLayout
          className="layout"
          layouts={layouts[section.id] || {}}
          onLayoutChange={(layout, allLayouts) =>
            onLayoutChange(layout, allLayouts, section.id)
          }
          breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
          cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
          rowHeight={100}
          draggableHandle={isEditMode ? ".drag-handle" : null}
          compactType="vertical"
          isDraggable={isEditMode}
          isResizable={isEditMode}
        >
          {sectionWidgets.map((widget) => {
            const widgetDefinition = widgetDefs[widget.type];
            return (
              <Box
                key={widget.i}
                data-grid={{
                  i: widget.i,
                  x: widget.x,
                  y: widget.y,
                  w: widget.w,
                  h: widget.h,
                  minW: widget.minW,
                  minH: widget.minH,
                  static: !isEditMode,
                }}
              >
                {renderWidget(widgetDefinition, widget.i)}
              </Box>
            );
          })}
        </ResponsiveGridLayout>
      </Box>
    );
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 400,
        }}
      >
        <Typography variant="h6" color="text.secondary">
          Loading dashboard layout...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      {/* Navbar-style section navigation with edit controls */}
      <AppBar
        position="static"
        elevation={0}
        sx={{
          mb: 3,
          backgroundColor: (theme) =>
            alpha(theme.palette.background.paper, 0.95),
          borderRadius: 2,
          border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.12)}`,
          overflow: "hidden",
        }}
      >
        <Toolbar sx={{ px: 3, minHeight: { xs: 56, sm: 64 } }}>
          {/* Section Tabs */}
          <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
            <Tabs
              value={selectedSectionIndex}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  minHeight: 48,
                  color: "text.primary",
                  "&.Mui-selected": {
                    color: "primary.main",
                  },
                },
                "& .MuiTabs-indicator": {
                  height: 3,
                  borderRadius: "3px 3px 0 0",
                },
              }}
            >
              {ROLE_BASED_DASHBOARD_SECTIONS[userRole].map((section, index) => {
                const sectionWidgets = widgets.filter(
                  (widget) => widget.sectionId === section.id
                );
                return (
                  <Tab
                    key={section.id}
                    label={
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="inherit">
                          {section.title}
                        </Typography>
                        <Chip
                          label={sectionWidgets.length}
                          size="small"
                          variant="outlined"
                          sx={{
                            height: 20,
                            fontSize: "0.7rem",
                            borderColor:
                              selectedSectionIndex === index
                                ? "primary.main"
                                : "text.secondary",
                            color:
                              selectedSectionIndex === index
                                ? "primary.main"
                                : "text.secondary",
                          }}
                        />
                      </Stack>
                    }
                  />
                );
              })}
            </Tabs>
          </Box>

          {/* Edit Mode Controls */}
          <Stack direction="row" alignItems="center" spacing={2}>
            {!hasUnsavedChanges && savedWidgets && (
              <Chip
                icon={<SaveIcon />}
                label="Layout Saved"
                color="success"
                variant="outlined"
                size="small"
              />
            )}

            {hasUnsavedChanges && (
              <Chip
                label="Unsaved Changes"
                color="warning"
                variant="filled"
                size="small"
                sx={{ animation: "pulse 1.5s infinite" }}
              />
            )}

            {isEditMode && (
              <Stack direction="row" spacing={1}>
                <Tooltip title="Add widget">
                  <IconButton onClick={handleAddWidgetClick} size="small">
                    <AddTaskIcon color="primary" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Save current layout" disableInteractive={false}>
                  <span style={{ display: "inline-flex" }}>
                    <IconButton
                      size="small"
                      onClick={hasUnsavedChanges ? handleSaveLayout : undefined}
                      disabled={!hasUnsavedChanges}
                      tabIndex={hasUnsavedChanges ? 0 : -1}
                    >
                      <SaveIcon color="success" />
                    </IconButton>
                  </span>
                </Tooltip>

                <Tooltip title="Cancel changes and revert to saved state">
                  <span style={{ display: "inline-flex" }}>
                    <IconButton
                      size="small"
                      onClick={handleCancelChanges}
                      disabled={!hasUnsavedChanges}
                    >
                      <CancelIcon color="warning" />
                    </IconButton>
                  </span>
                </Tooltip>

                <Tooltip title="Reset to default layout">
                  <IconButton size="small" onClick={handleResetLayout}>
                    <RefreshIcon color="error" />
                  </IconButton>
                </Tooltip>
              </Stack>
            )}

            <Button
              variant={isEditMode ? "contained" : "outlined"}
              color={isEditMode ? "warning" : "primary"}
              size="medium"
              startIcon={isEditMode ? <VisibilityIcon /> : <EditIcon />}
              onClick={handleModeToggle}
              sx={{
                minWidth: 130,
                height: 40,
                textTransform: "none",
                fontWeight: 600,
                borderRadius: 2,
                ml: 1,
              }}
            >
              {isEditMode ? "View Mode" : "Edit Mode"}
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>

      <style>
        {`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.7; }
            100% { opacity: 1; }
          }
        `}
      </style>

      <Menu
        anchorEl={anchorEl}
        open={openAddWidgetMenu}
        onClose={handleAddWidgetClose}
        PaperProps={{
          sx: {
            maxHeight: 500,
            minWidth: 300,
            borderRadius: 2,
            border: (theme) =>
              `1px solid ${alpha(theme.palette.divider, 0.12)}`,
          },
        }}
      >
        {ROLE_BASED_DASHBOARD_SECTIONS[userRole]
          .map((section, sectionIndex) => [
            <MenuItem
              key={`section-title-${section.id}`}
              disabled
              sx={{
                opacity: 1,
                backgroundColor: (theme) =>
                  alpha(theme.palette.primary.main, 0.04),
                borderBottom: (theme) =>
                  `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                "&.Mui-disabled": {
                  opacity: 1,
                },
              }}
            >
              <Typography
                variant="subtitle2"
                color="primary"
                fontWeight={700}
                sx={{ fontSize: "0.85rem" }}
              >
                {section.title}
              </Typography>
            </MenuItem>,
            ...section.widgets.map((widgetKey) => {
              const widgetDefinition = WIDGET_DEFINITIONS[widgetKey];
              const isWidgetTypePresent = widgets.some(
                (w) => w.type === widgetKey
              );
              return (
                <MenuItem
                  key={`${section.id}-${widgetKey}`}
                  onClick={(e) => e.stopPropagation()}
                  sx={{
                    minWidth: 300,
                    pl: 3,
                    py: 1,
                    "&:hover": {
                      backgroundColor: (theme) =>
                        alpha(theme.palette.primary.main, 0.04),
                    },
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        checked={isWidgetTypePresent}
                        onChange={(event) =>
                          handleToggleWidget(
                            widgetKey,
                            event.target.checked,
                            section.id
                          )
                        }
                        onClick={(e) => e.stopPropagation()}
                        color="primary"
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: isWidgetTypePresent ? 600 : 400,
                          color: isWidgetTypePresent
                            ? "primary.main"
                            : "text.primary",
                        }}
                      >
                        {widgetDefinition.name}
                      </Typography>
                    }
                    sx={{
                      width: "100%",
                      justifyContent: "space-between",
                      ml: 0,
                    }}
                    labelPlacement="start"
                  />
                </MenuItem>
              );
            }),
            sectionIndex <
              ROLE_BASED_DASHBOARD_SECTIONS[userRole].length - 1 && (
              <Divider key={`divider-${section.id}`} />
            ),
          ])
          .flat()
          .filter(Boolean)}
      </Menu>

      {/* Render only the selected section */}
      {ROLE_BASED_DASHBOARD_SECTIONS[userRole][selectedSectionIndex] &&
        renderSection(
          ROLE_BASED_DASHBOARD_SECTIONS[userRole][selectedSectionIndex]
        )}

      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}
